import { sendPost } from "../helpers";

const postDataMember = async (params, onSucces = () => {}, onError = () => {}) => {
    try {
      const res = await sendPost("/family/edit", params);
      if (res.status === 200) {
        if (res?.data.result === "failure") {
          onError(res?.data.reason)
        } else {
          onSucces(res?.data);
        }
      } else {
        onError(res?.data.reason)
      }
    } catch (error) {
    }
}
    const  ListMembers = {postDataMember};
    export default ListMembers;